import { render, staticRenderFns } from "./DictionariesSettingsList.vue?vue&type=template&id=0309191c&scoped=true&"
import script from "./DictionariesSettingsList.vue?vue&type=script&lang=js&"
export * from "./DictionariesSettingsList.vue?vue&type=script&lang=js&"
import style0 from "./DictionariesSettingsList.vue?vue&type=style&index=0&id=0309191c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0309191c",
  null
  
)

export default component.exports